export const Border = {
  // Header
  header: {
    title: 'Bordas Personalizadas',
    subtitle: 'Destaque o player com bordas modernas e flexíveis, sem perder a identidade visual.',
  },
  
  // Enable toggle
  enable: 'Ativar borda no player',
  enableHelper: 'Habilita a personalização de bordas ao redor do vídeo.',
  
  // Style presets
  style: {
    title: 'Estilo de borda (preset)',
    helper: 'Escolha um estilo pronto ou ajuste manualmente abaixo.',
    none: 'Nenhum',
    modern: 'Moderno',
    highlight: 'Destaque',
    neon: 'Neon',
    custom: 'Personalizado'
  },
  
  // Appearance
  appearance: {
    title: 'Aparência',
    color: 'Cor da borda',
    thickness: 'Espessura',
    radius: 'Arredondamento dos cantos',
  },
  
  // Shadow
  shadow: {
    toggle: 'Adicionar sombra externa',
    color: 'Cor da sombra',
    blur: 'Desfoque',
    intensity: 'Intensidade',
  },
  
  
  // Legacy (mantido para compatibilidade)
  customizeBorder: 'Borda Customizada',
  enableBorder: 'Ativar Borda',
  borderColor: 'Cor da Borda',
  borderWidth: 'Espessura da Borda',
  borderRadius: 'Arredondamento da Borda',
  borderDescription: 'A borda será aplicada ao redor do player conforme largura e cor escolhidas.',
  borderSettings: 'Configurações da Borda',
  stylePreset: 'Estilos Rápidos',
  presetNone: 'Sem Borda',
  presetModern: 'Moderna',
  presetHighlight: 'Destaque',
  presetNeon: 'Neon',
  apply: 'Aplicar',
  saveAll: 'Salvar tudo'
};